import React from 'react';

import type { SelectClasses } from '@mui/material';
import clsx from 'clsx';
import { useField } from 'formik';
import { CheckMarkMenuItem } from 'src/components/index';
import { makeStyles } from 'tss-react/mui';

import { FormikBaseSelect } from './FormikBaseSelect';
import { useInputStyles } from './useInputStyles';

const useStyles = makeStyles()(theme => ({
  inputText: {
    padding: theme.spacing(0, 1),
  },
}));

interface FormikOptionsSelectProps<T> {
  fieldName: string;
  options: { label: string; value: T }[];
  className?: string;
  disabled?: boolean;
  onSelectChange?: (value: T) => void;
  renderValue?: (value: string) => JSX.Element;
  selectClasses?: Partial<SelectClasses>;
}

export function FormikOptionsSelect<T extends string>(
  props: FormikOptionsSelectProps<T>
): JSX.Element {
  const { className, disabled, fieldName, onSelectChange, options, renderValue, selectClasses } =
    props;
  props;
  const { classes } = useStyles();
  const { classes: inputClasses } = useInputStyles({});

  const [field, , { setValue }] = useField<T | undefined>(fieldName);

  return (
    <FormikBaseSelect
      className={className}
      disabled={disabled}
      fieldName={fieldName}
      renderValue={(value: unknown) => {
        const label = options.find(option => option.value === value)?.label ?? '';
        if (renderValue) return renderValue(label);
        return <span className={clsx(inputClasses.inputText, classes.inputText)}>{label}</span>;
      }}
      selectClasses={selectClasses}
    >
      {options.map((option, index) => {
        return (
          <CheckMarkMenuItem
            key={index}
            disabled={disabled}
            selected={option.value === field.value}
            value={option.value}
            onClick={() => {
              setValue(option.value);
              if (onSelectChange) {
                onSelectChange(option.value);
              }
            }}
          >
            {option.label}
          </CheckMarkMenuItem>
        );
      })}
    </FormikBaseSelect>
  );
}
